import type { MealWriteQueue } from "../../application/meal-write-queue";
import { useEffect, useState } from "react";
import type { MealRepository } from "../../application/meal-repository";
import { MealTransferError, mealTransferRoute, readMealTransfer } from "../../application/meal-transfer";
import type { ISODate, MealType } from "../../domain/model";
import { mealTypeLabels } from "../../application/meal-detection";

export function useMealTransfer(repository: MealRepository, sourceDate: ISODate, queue: MealWriteQueue, onTransferred: (date: ISODate, mealType: MealType) => void) {
  const [notice, setNotice] = useState<{ date: ISODate; text: string } | null>(null);
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => setNotice(null), 6_000);
    return () => window.clearTimeout(timer);
  }, [notice]);
  const transferMeal = async (answer: string, sourceType: MealType, itemIndex: number | null = null) => {
    const command = readMealTransfer(answer);
    if (!command) return false;
    if (itemIndex !== null) throw new MealTransferError("Для переноса всей еды используйте микрофон внизу открытого приёма пищи.");
    const { source, target } = mealTransferRoute(command, sourceDate, sourceType);
    const operation = queue.enqueue(() => repository.transferMeal(source.date, source.mealType, target.date, target.mealType, command.mode));
    try { await operation; }
    catch (error) {
      if (error instanceof MealTransferError) throw error;
      throw new MealTransferError("Не удалось перенести или скопировать еду. Записи не изменились — попробуйте ещё раз.");
    }
    setNotice({ date: target.date, text: `${command.mode === "copy" ? "Еда скопирована" : "Еда перенесена"}: ${mealTypeLabels[target.mealType].toLocaleLowerCase("ru-RU")}, ${target.date.split("-").reverse().join(".")}.` });
    onTransferred(target.date, target.mealType);
    return true;
  };
  return { transferMeal, notice };
}
